var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropArea",staticClass:"drag-drop-area",class:_vm.statusClass},[_vm._t("default"),_c('input',{attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.updateFileHandler}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }